
import type { MessageCategory } from "@/types/chat";

// Timing più realistici e vari (1.5-8 secondi)
export const ADVANCED_MESSAGE_TIMINGS = [
  1500,  // 1.5s - Riconoscimento rapido
  2800,  // 2.8s - Analisi iniziale
  4200,  // 4.2s - Consultazione dati
  3500,  // 3.5s - Elaborazione
  5800,  // 5.8s - Verifica
  2200,  // 2.2s - Calcolo
  6500,  // 6.5s - Consultazione mercati
  3800,  // 3.8s - Finalizzazione
  4800,  // 4.8s - Controllo qualità
  7200   // 7.2s - Preparazione risposta
];

export const CONTEXTUAL_WAITING_MESSAGES: Record<MessageCategory, string[]> = {
  COMPRO_ORO: [
    "Sto consultando la rete di 847 compro oro certificati in Italia...",
    "Verifico le licenze e autorizzazioni degli operatori nella tua zona...",
    "Controllo le recensioni e valutazioni degli ultimi 30 giorni...",
    "Analizzo i prezzi di acquisto aggiornati in tempo reale...",
    "Consulto il database delle quotazioni dealer autorizzati...",
    "Verifico la disponibilità e gli orari di apertura attuali...",
    "Controllo le specializzazioni per tipologia di metallo prezioso...",
    "Valuto la distanza e accessibilità dei punti vendita...",
    "Analizzo le politiche di ritiro e pagamento immediate...",
    "Confronto i margini applicati dai diversi operatori..."
  ],

  PREZZI_ORO: [
    "Consultando il London Bullion Market Association (LBMA)...",
    "Aggiornamento dal fixing delle 15:00 GMT ricevuto...",
    "Verifico le quotazioni spot in tempo reale da Londra...",
    "Controllo l'andamento sui mercati internazionali...",
    "Analizzo la volatilità delle ultime 24 ore...",
    "Consulto i dati di trading del COMEX di New York...",
    "Verifico le quotazioni per diverse carature (18kt, 24kt)...",
    "Controllo l'impatto del cambio EUR/USD sui prezzi...",
    "Analizzo i volumi di scambio odierni...",
    "Aggiorno i calcoli con lo spread italiano attuale..."
  ],

  PREZZI_ARGENTO: [
    "Consultando il COMEX per le quotazioni silver spot...",
    "Verifico i prezzi sul London Metal Exchange (LME)...",
    "Controllo le quotazioni per argento 925 sterling...",
    "Analizzo l'andamento argento puro 999‰...",
    "Verifico i dati di trading dal NYMEX...",
    "Controllo la correlazione oro-argento odierna...",
    "Analizo le scorte e forniture mondiali...",
    "Verifico l'impatto industriale sui prezzi...",
    "Consulto i futures sull'argento a 3 mesi...",
    "Aggiorno con i differenziali del mercato europeo..."
  ],

  PREZZI_GENERALI: [
    "Sincronizzando con i mercati globali dei metalli preziosi...",
    "Verifico l'apertura delle borse internazionali...",
    "Controllo gli aggiornamenti da Shanghai Gold Exchange...",
    "Analizzo i trend sui mercati asiatici...",
    "Verifico l'impatto delle notizie economiche...",
    "Controllo la correlazione con dollaro e euro...",
    "Analizzo la volatilità del mercato odierno...",
    "Verifico i volumi di trading istituzionali...",
    "Consulto gli indicatori tecnici principali...",
    "Aggiorno con le previsioni del Federal Reserve..."
  ],

  VALUTAZIONE: [
    "Calcolo il valore basato sulle quotazioni LBMA aggiornate...",
    "Verifico il titolo e la purezza del metallo...",
    "Applico i coefficienti per la caratura specifica...",
    "Controllo i fattori di conversione grammi/once...",
    "Analizzo il peso specifico e la composizione...",
    "Verifico eventuali leghe e impurità...",
    "Calcolo il valore intrinseco del metallo puro...",
    "Applico i margini di mercato standard...",
    "Controllo la conformità ai test di purezza...",
    "Finalizzo la stima con i prezzi di acquisto attuali..."
  ],

  LOCALIZZAZIONE: [
    "Identifico la tua posizione geografica...",
    "Calcolo le distanze dai punti vendita più vicini...",
    "Verifico la copertura nella tua provincia...",
    "Controllo i trasporti pubblici per raggiungere i dealer...",
    "Analizzo la densità di compro oro nella zona...",
    "Verifico gli orari di apertura nel tuo fuso orario...",
    "Controllo la disponibilità di parcheggio...",
    "Analizzo le recensioni locali dei clienti...",
    "Verifico le specializzazioni regionali...",
    "Calcolo i tempi di percorrenza ottimali..."
  ],

  GENERALE: [
    "Elaboro la tua richiesta con i dati più aggiornati...",
    "Consulto il database delle informazioni sui metalli preziosi...",
    "Verifico le ultime normative del settore...",
    "Controllo gli aggiornamenti normativi italiani...",
    "Analizzo le tendenze del mercato odierno...",
    "Verifico la disponibilità delle informazioni richieste...",
    "Consulto le guide e procedure standard...",
    "Controllo la conformità alle best practices...",
    "Analizzo i fattori economici rilevanti...",
    "Preparo una risposta completa e aggiornata..."
  ]
};

export const TIME_BASED_MESSAGES: Record<string, string[]> = {
  market_hours: [
    "I mercati sono aperti, ottengo quotazioni in tempo reale...",
    "Verifico il trading attivo sui mercati internazionali...",
    "Controllo i volumi di scambio dell'ora corrente...",
    "Analizzo la volatilità durante la sessione europea..."
  ],
  
  after_hours: [
    "I mercati principali sono chiusi, uso le ultime quotazioni...",
    "Verifico il trading after-hours sui mercati asiatici...",
    "Controllo i futures per la sessione di domani...",
    "Analizzo i dati dell'ultima sessione di trading..."
  ],
  
  weekend: [
    "Durante il weekend uso le quotazioni di venerdì...",
    "Verifico eventuali gap apertura previsti per lunedì...",
    "Controllo i mercati aperti in altre zone orarie...",
    "Analizzo i trend settimanali consolidati..."
  ]
};

export const COMPLEXITY_BASED_MESSAGES: Record<string, string[]> = {
  simple: [
    "Ricerca informazione richiesta...",
    "Verifica dati aggiornati...",
    "Calcolo risposta...",
    "Controllo accuratezza..."
  ],
  
  medium: [
    "Analizzo la richiesta multifunzione...",
    "Elaboro i diversi aspetti della domanda...",
    "Verifico correlazioni tra i dati...",
    "Compilo una risposta articolata..."
  ],
  
  complex: [
    "Elaboro la richiesta complessa con analisi approfondita...",
    "Verifico molteplici fonti dati per completezza...",
    "Analizzo le interconnessioni tra i fattori richiesti...",
    "Preparo una risposta dettagliata e strutturata..."
  ]
};

export const PROGRESSIVE_MESSAGES = {
  phase1: "🔍 Identificazione",
  phase2: "📊 Consultazione dati", 
  phase3: "⚡ Elaborazione",
  phase4: "✅ Finalizzazione"
};

export const FINAL_MESSAGE_DELAY = 2000; // 2 secondi per il messaggio finale

export const FINAL_MESSAGES = [
  "Completando l'analisi con gli ultimi aggiornamenti...",
  "Verifico la coerenza delle informazioni raccolte...",
  "Preparo la risposta finale con tutti i dettagli...",
  "Ottimizzando la presentazione dei risultati...",
  "Controllo finale qualità e accuratezza dati..."
];

// Funzione per timing dinamico basato su contesto
export function generateContextualDelay(category: MessageCategory, messageIndex: number): number {
  const baseTimings = ADVANCED_MESSAGE_TIMINGS;
  const timing = baseTimings[messageIndex % baseTimings.length];
  
  // Modificatori per categoria
  const categoryModifiers: Record<MessageCategory, number> = {
    'COMPRO_ORO': 1.0,      // Normale
    'PREZZI_ORO': 0.8,      // Più veloce (dati più diretti)
    'PREZZI_ARGENTO': 0.8,  // Più veloce
    'PREZZI_GENERALI': 1.2, // Più lento (più complesso)
    'VALUTAZIONE': 1.1,     // Leggermente più lento
    'LOCALIZZAZIONE': 0.9,  // Più veloce (GPS/dati locali)
    'GENERALE': 1.0         // Normale
  };
  
  const modifier = categoryModifiers[category] || 1.0;
  return Math.round(timing * modifier);
}

// Funzione per selezionare messaggi basati su tempo
export function getTimeBasedMessage(category: MessageCategory): string | null {
  const now = new Date();
  const hour = now.getHours();
  const day = now.getDay();
  
  if (day === 0 || day === 6) {
    return TIME_BASED_MESSAGES.weekend[Math.floor(Math.random() * TIME_BASED_MESSAGES.weekend.length)];
  } else if (hour >= 9 && hour <= 17) {
    return TIME_BASED_MESSAGES.market_hours[Math.floor(Math.random() * TIME_BASED_MESSAGES.market_hours.length)];
  } else {
    return TIME_BASED_MESSAGES.after_hours[Math.floor(Math.random() * TIME_BASED_MESSAGES.after_hours.length)];
  }
}
